// Season values shared by the scenery shaders: snow, dry grass and the birch leaves. One set of
// uniforms for the whole page; the Environment sets them from calendar.ts and the shaders read them.
import { Uniform } from 'three';
import { COURSE } from './layout';

export const SEASON_UNIFORMS = {
  /** Snow on the ground, 0..1. */
  uSnow: new Uniform(0),
  /** Faded, dry grass, 0..1. */
  uDryGrass: new Uniform(0),
  /** Leaves on the birches, 0 (bare) to 1. */
  uLeaves: new Uniform(1),
  /** Autumn colour of the birch leaves, 0..1. */
  uAutumn: new Uniform(0),
  /** Fresh spring green, 0..1. */
  uSpring: new Uniform(0),
  /** How much sunlight glows through the leaves, 0 (sun down) to 1. */
  uSunGlow: new Uniform(1),
  /** Floodlights, 0 (day) to 1 (night): scenery far from the stadium falls dark. */
  uFlood: new Uniform(0),
};

/**
 * GLSL: how much of the key light reaches a world point. By day everything is sunlit; at night
 * the floodlights reach the course and the stands, and the forest and fields beyond fall dark.
 * Bind uFlood from SEASON_UNIFORMS.
 */
export const GLSL_FLOOD_REACH = /* glsl */ `
uniform float uFlood;
float floodReach(vec3 wp) {
  float dz = max(0.0, abs(wp.z) - 14.0);
  float dx = max(0.0, max(${(COURSE.from - 10).toFixed(1)} - wp.x, wp.x - ${(COURSE.to + 10).toFixed(1)}));
  return mix(1.0, 0.08 + 0.92 * exp(-length(vec2(dx, dz)) / 28.0), uFlood);
}
`;
